"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PhotosSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var PhotosSVG = function PhotosSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M28,5H8A2.0059,2.0059,0,0,0,6,7v3H4a2.0059,2.0059,0,0,0-2,2V26a2.0059,2.0059,0,0,0,2,2H23a2.0059,2.0059,0,0,0,2-2V24h3a2.0059,2.0059,0,0,0,2-2V7A2.0059,2.0059,0,0,0,28,5ZM13,9a2,2,0,1,1-2,2A2,2,0,0,1,13,9ZM23,26H4V12H6V22a2.0059,2.0059,0,0,0,2,2H23Zm5-10v6H9.5859l7.7071-7.707a.9994.9994,0,0,1,1.414,0L21,16.5859l3.293-3.2929a.9994.9994,0,0,1,1.414,0L28,15.5859Z"
  }));
};
exports.PhotosSVG = PhotosSVG;
PhotosSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(PhotosSVG);
exports.default = _default;